import { actionOnMessage } from '@skynet/data-ws-mm';

import { ExchangeCommands, initExchangeSlice } from '@skynet/data-shared-exchanges';
import type { ExchangesState } from '@skynet/data-shared-exchanges';

// Exchanges command is sent by the server on auth success,
// so we can set the initial status to 'pending' by default
export const initialState: ExchangesState = {
  requestStatus: 'pending',
  error: null,
  list: [],
};

const { reducer, actions } = initExchangeSlice({
  commands: ExchangeCommands,
  messages: actionOnMessage,
  initialState,
});

export const exchangesActions = actions;

export default reducer;
